import { FiltersFromQuery } from 'apps/cms/components/Flows/components/FlowCard/components/Triggers/hooks/useTriggers/lib/filtersMatching/types'
import { FsTriggerModel } from 'shared/api/requests/cms/schemas'

export const isExternalTrigger = (query: FiltersFromQuery) =>
  !query.channel && query.trigger_model === FsTriggerModel.EXTERNAL_TRIGGER && !query.widget_type
